import React from 'react';
import {Button, Card, Divider, Space, Typography} from 'antd';
import {useLocation, useNavigate} from 'react-router-dom';
import {ROUTES} from '../routes/constants';

const { Title, Paragraph, Text } = Typography;

const Demo: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="demo-page" style={{ padding: '24px' }}>
      <Card>
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <Title level={2}>路由功能演示</Title>
          
          <div>
            <Title level={3}>当前页面信息</Title>
            <Paragraph>
              <Text strong>当前路径:</Text> {location.pathname}<br/>
              <Text strong>完整URL:</Text> {location.pathname + location.search + location.hash}
            </Paragraph>
          </div>

          <Divider />

          <div>
            <Title level={3}>页面导航</Title>
            <Space wrap>
              <Button type="primary" onClick={() => navigate(ROUTES.HOME)}>
                首页
              </Button>
              <Button onClick={() => navigate(ROUTES.MONITOR)}>
                监控页面
              </Button>
              <Button onClick={() => navigate(ROUTES.ABOUT)}>
                关于页面
              </Button>
              <Button onClick={() => navigate('/demo')}>
                当前页面
              </Button>
            </Space>
          </div>

          <Divider />

          <div>
            <Title level={3}>编程式导航</Title>
            <Space direction="vertical">
              <Button onClick={() => navigate(-1)}>
                返回上一页
              </Button>
              <Button onClick={() => navigate('/non-existent-page')}>
                访问不存在的页面 (404)
              </Button>
            </Space>
          </div>

          <Divider />

          <div>
            <Title level={3}>路由特性</Title>
            <Paragraph>
              ✅ 支持多页面展示<br/>
              ✅ 导航菜单高亮当前页面<br/>
              ✅ 404 页面处理<br/>
              ✅ 编程式导航<br/>
              ✅ 路由常量管理<br/>
              ✅ TypeScript 类型支持
            </Paragraph>
          </div>
        </Space>
      </Card>
    </div>
  );
};

export default Demo; 